import type { RootState } from 'store';

// eslint-disable-next-line import/prefer-default-export
export const selectMe = (state: RootState) => state.me;

// eslint-disable-next-line import/prefer-default-export
export const selectPartners = (state: RootState) => state.partners;
